import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { BfxBlotterOpsIntComponent } from "./bfx-blotter-ops-int.component";

@Component({
  selector: "bfx-blotter-ops-int-top-menu",
  templateUrl: "./html/bfx-blotter-ops-int-top-menu.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BfxBlotterOpsIntTopMenuComponent {
  constructor(@Inject(BfxBlotterOpsIntComponent) public parent: BfxBlotterOpsIntComponent) {}
}
